import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPosts } from "../../features/posts/postsSlice";
import Post from "./Post";

export default function Posts() {
  const dispatch = useDispatch();
  const { posts, isLoading, isError, error } = useSelector(
    (state) => state.posts
  );
  const { filter, sort } = useSelector((state) => state.filter);

  useEffect(() => {
    dispatch(fetchPosts());
  }, [dispatch]);

  let filteredPosts = posts;
  if (filter !== "all") {
    filteredPosts = posts.filter((post) => post.isSaved === true);
  }

  let sortedPosts = [...filteredPosts];
  if (sort === "newest") {
    sortedPosts = sortedPosts.sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );
  } else if (sort === "most_liked") {
    sortedPosts = sortedPosts.sort((a, b) => b.likes - a.likes);
  }

  // decide what to render
  let content;

  if (isLoading) content = <div className="col-span-12">Loading...</div>;
  if (!isLoading && isError)
    content = <div className="col-span-12">{error}</div>;

  if (!isError && !isLoading && sortedPosts?.length === 0) {
    content = <div className="col-span-12">No posts found!</div>;
  }

  if (!isError && !isLoading && sortedPosts?.length > 0) {
    content = sortedPosts.map((post) => <Post key={post.id} post={post} />);
  }

  return (
    <main className="post-container" id="lws-postContainer">
      {content}
    </main>
  );
}
